export default __webpack_public_path__ + "static/media/14_photo.8f60c394.jpg";